import { createTheme } from '@mui/material/styles';
import { CommonThemeOptions } from './commonTheme';
import { type IThemeOptions } from './index';

export const Violin2NotesOptions: IThemeOptions = {
  ...CommonThemeOptions,
  themeName: 'Violin2Notes',
  components: {
    ...CommonThemeOptions.components,
    MuiButton: {
      styleOverrides: {
        textPrimary: {
          color: '#786ae1',
          '&.Mui-disabled': {
            color: '#504696',
          },
        },
        outlinedPrimary: {
          color: '#786ae1',
          '&.Mui-disabled': {
            color: '#504696',
            border: '1px solid #504696',
          },
        },
        containedPrimary: {
          backgroundColor: '#786ae1',
          '&.Mui-disabled': {
            backgroundColor: '#504696',
            color: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        primary: {
          color: '#fff',
          backgroundColor: '#786ae1',
          background: '#786ae1', // transcribe button
          '&.Mui-disabled': {
            background: '#caced133',
            color: '#ffffff42',
          },
        },
      },
    },
  },
  palette: {
    ...CommonThemeOptions.palette,
    primary: {
      main: '#786ae1',
      light: '#9790CB',
      dark: '#504696',
      contrastText: '#fff',
    },
  },
};

export const Violin2NotesTheme = createTheme(Violin2NotesOptions);
